/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewDecisionsSummary } from './CRSFSecReviewDecisionsSummary';
import {
    CRSFSecReviewDecisionsSummaryFromJSON,
    CRSFSecReviewDecisionsSummaryFromJSONTyped,
    CRSFSecReviewDecisionsSummaryToJSON,
} from './CRSFSecReviewDecisionsSummary';
import type { CRSFSecReviewScanType } from './CRSFSecReviewScanType';
import {
    CRSFSecReviewScanTypeFromJSON,
    CRSFSecReviewScanTypeFromJSONTyped,
    CRSFSecReviewScanTypeToJSON,
} from './CRSFSecReviewScanType';

/**
 * 
 * @export
 * @interface CRSFSecReviewGetTicketResponse
 */
export interface CRSFSecReviewGetTicketResponse {
    /**
     * 
     * @type {CRSFSecReviewDecisionsSummary}
     * @memberof CRSFSecReviewGetTicketResponse
     */
    data?: CRSFSecReviewDecisionsSummary;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewGetTicketResponse
     */
    process_id: string;
    /**
     * 
     * @type {CRSFSecReviewScanType}
     * @memberof CRSFSecReviewGetTicketResponse
     */
    scan_type: CRSFSecReviewScanType;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewGetTicketResponse
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewGetTicketResponse
     */
    ticket: string;
}

/**
 * Check if a given object implements the CRSFSecReviewGetTicketResponse interface.
 */
export function instanceOfCRSFSecReviewGetTicketResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "process_id" in value;
    isInstance = isInstance && "scan_type" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "ticket" in value;

    return isInstance;
}

export function CRSFSecReviewGetTicketResponseFromJSON(json: any): CRSFSecReviewGetTicketResponse {
    return CRSFSecReviewGetTicketResponseFromJSONTyped(json, false);
}

export function CRSFSecReviewGetTicketResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewGetTicketResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : CRSFSecReviewDecisionsSummaryFromJSON(json['data']),
        'process_id': json['process_id'],
        'scan_type': CRSFSecReviewScanTypeFromJSON(json['scan_type']),
        'status': json['status'],
        'ticket': json['ticket'],
    };
}

export function CRSFSecReviewGetTicketResponseToJSON(value?: CRSFSecReviewGetTicketResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CRSFSecReviewDecisionsSummaryToJSON(value.data),
        'process_id': value.process_id,
        'scan_type': CRSFSecReviewScanTypeToJSON(value.scan_type),
        'status': value.status,
        'ticket': value.ticket,
    };
}

